import { UnifiedGraftModelTypeKey } from '@/core/const/unifiedGraftModelTypeKeys.const'
import type { TypeDef } from '@/core/types/library.type'

import { getUnifiedGraftModelType } from './getUnifiedGraftModelType'

type GraftModelNodeLike = {
  unifiedGraftModelType?: unknown
  graftModelType?: unknown
}

const hasGraftModelType = (value: unknown): value is GraftModelNodeLike =>
  typeof value === 'object' &&
  value !== null &&
  (Object.hasOwn(value as object, 'unifiedGraftModelType') || Object.hasOwn(value as object, 'graftModelType'))

/**
 * Type guard: true if the graft model node is a TYPE_DEF (class/type definition).
 */
export const isTypeDef = (value: unknown): value is TypeDef => {
  if (!hasGraftModelType(value)) {
    return false
  }

  const type = getUnifiedGraftModelType(value)
  return type === UnifiedGraftModelTypeKey.TYPE_DEF
}
